import React from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import styles from "./Table.module.css";
import { CSVLink } from "react-csv";

const TablePagination = ({
  columns,
  data,
  rowClickHandler,
  onClickHandler,
}) => {
  let count = 0;

  // Use the useTable Hook to send the columns and data to build the table
  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    //rows, // rows for the table based on the data passed
    prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
  );

  const showPagination = () => {
    return (
      <div className={styles.pagination}>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>{" "}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>{" "}
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        {paginationSelect()}
        {showCSVLink()}
      </div>
    );
  };

  const paginationSelect = () => {
    return (
      <select
        className={styles.showDropdown}
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
        }}
      >
        {[10, 20, 30, 50, 100].map((pageSize) => (
          <option className={styles.showOption} key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>
    );
  };

  const showCSVLink = () => {
    return (
      <div>
        <CSVLink className={styles.csvLink} data={data}>
          Download CSV
        </CSVLink>
      </div>
    );
  };

  const customButtonCell = (cell) => {
    return (
      <td key={`cell${count++}`}>
        <button
          className={styles.cellLinkButton}
          onClick={() => onClickHandler(cell.value)}
        >
          {cell.value}
        </button>
      </td>
    );
  };

  const defaultCell = (cell) => {
    return (
      <td key={`cell${count++}`} {...cell.getCellProps()}>
        {cell.render("Cell")}
      </td>
    );
  };

  return (
    <React.Fragment>
      <div className={styles.tableDiv}>
        <table {...getTableProps()} className={styles.tableData}>
          <thead className={styles.tableHeader}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    className={styles.tableTH}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  className={styles.dataRow}
                  {...row.getRowProps()}
                  //onClick={() => rowClickHandler(row)}
                >
                  {row.cells.map((cell) => {
                    switch (cell.column.Header) {
                      case "Contractor Audit ID":
                        return customButtonCell(cell);
                      default:
                        return defaultCell(cell);
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {showPagination()}
    </React.Fragment>
  );
};

export default TablePagination;
